import Ink from "@frog/source/utility/Ink.js"
import Stage from "@frog/source/models/Stage.js"
import Navigation from "@frog/source/models/Navigation.js"

export default function InkDialogue(knotname) {
    return {
        "type": "InkDialogue-" + knotname,
        "func": function(stage) {
            const dialogues = Ink.loadDialogue(knotname)

            if(dialogues.length == 0) return []

            const events = dialogues.map((dialogue) => {
                return {
                    "type": "StartDialogue",
                    "isImportant": true,
                    "duration": Infinity,
                    "deltastages": [
                        {
                            "mark": 0,
                            "dialogue": dialogue,
                        }
                    ]
                }
            })
            events.push({
                "type": "FinishDialogue",
                "deltastages": [
                    {
                        "mark": 0,
                        "dialogue": null
                    }
                ]
            })

            if(dialogues[dialogues.length - 1] != undefined
            && dialogues[dialogues.length - 1].text != undefined
            && dialogues[dialogues.length - 1].text.includes("WEYLAN: Well you've helped bring us back to life. Thank you.")) {

              events.push({
                  "func": function() {
                       Navigation.go("/credits")
                  }
              })
            }

            return Stage.processEventSteps(stage, events)
        }
    }
}
